.row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--tuna-spacing-1);
  padding: var(--tuna-spacing-1) 0;
}

.who {
  display: flex;
  align-items: center;
  gap: var(--tuna-spacing-1);
  min-width: 0;
}

.text {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.sentence {
  overflow-wrap: anywhere;
}

.icon {
  display: inline-flex;
  vertical-align: middle;
  margin-right: var(--tuna-spacing-0_5);
}

.meta {
  color: var(--tuna-content-secondary);
}

.actions {
  display: flex;
  gap: var(--tuna-spacing-1);
  flex: none;
}

.split {
  flex: none;
}

/* Phones (<900px): the sentence on line one, actions left-aligned on line two, 44px targets (§8.5) */
@media (max-width: 899.95px) {
  .row {
    flex-direction: column;
    align-items: flex-start;
  }

  .action {
    min-height: 44px;
  }
}
